import script from "./FileJobElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileJobElement.vue?vue&type=script&setup=true&lang=ts"

import "./FileJobElement.vue?vue&type=style&index=0&id=225d5444&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225d5444"]])

export default __exports__